import { Component } from '@angular/core';
import { ColumnHyperlinkDto } from 'webcommon/shared';
import { ApColumnBase } from './ap-column-base';

@Component({
  selector: 'ap-hyperlink-column-selector',
  templateUrl: './ap-hyperlink-column-selector.component.html',
})
export class ApHyperlinkColumnSelectorComponent extends ApColumnBase<ColumnHyperlinkDto> {
  load() {
    return;
  }
}
